// extracted by mini-css-extract-plugin
export var orderSummary = "_p9-0";
export var showMoreLessButton = "_p9-1";